export const fetchFormData = (params) =>
  $.ajax({
    method: 'GET',
    url: '/vet-portal/reseller/forms',
    data: params,
  });

export const updateForm = (params) =>
  $.ajax({
    method: 'PATCH',
    beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    },
    url: `/vet-portal/reseller/forms`,
    contentType: 'application/json',
    data: JSON.stringify(params),
  });

export const submitForm = (params) =>
  $.ajax({
    method: 'POST',
    beforeSend(xhr) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    },
    url: `/vet-portal/reseller/submit_form`,
    contentType: 'application/json',
    data: JSON.stringify(params),
  });
